export default __webpack_public_path__ + "static/media/BusinessIcon.9489400a.svg";